import React from 'react';
import { Check } from 'lucide-react';

const StepIndicator = ({ steps, current }) => (
  <div className="flex items-center gap-0 mb-8">
    {steps.map((step, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <React.Fragment key={step}>
          {/* Circle */}
          <div className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2 transition-all duration-300
                ${done  ? 'bg-zip-red border-zip-red text-white'
                : active ? 'bg-transparent border-zip-red text-zip-red'
                : 'bg-transparent border-zip-border text-zip-muted'}`}
            >
              {done ? <Check size={14} /> : i + 1}
            </div>
            <span className={`text-[11px] mt-1.5 font-medium whitespace-nowrap
              ${active ? 'text-zip-text' : done ? 'text-zip-muted' : 'text-zip-muted'}`}>
              {step}
            </span>
          </div>

          {/* Connector */}
          {i < steps.length - 1 && (
            <div className="relative h-0.5 flex-1 mx-2 bg-zip-border overflow-hidden" style={{ marginBottom: '18px' }}>
              <div
                className="absolute inset-0 bg-zip-red transition-all duration-500 ease-out origin-left"
                style={{ transform: `scaleX(${done ? 1 : 0})` }}
              />
            </div>
          )}
        </React.Fragment>
      );
    })}
  </div>
);

export default StepIndicator;
